import { z } from 'zod';
import { TenantPublicSchema } from '../entities/tenant.js';
import { TenantUserPublicSchema } from '../entities/tenantUser.js';
// =========================================================
// /v1/me — see docs/api.md §3.2
// =========================================================
// GET /v1/me
export const MeGetResponseSchema = z.object({
    user: TenantUserPublicSchema,
    tenant: TenantPublicSchema,
});
// PATCH /v1/me
export const MePatchRequestSchema = z
    .object({
    firstName: z.string().min(1).max(60).optional(),
    lastName: z.string().min(1).max(60).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'At least one field required.' });
export const MePatchResponseSchema = TenantUserPublicSchema;
// POST /v1/me/password
export const MeChangePasswordRequestSchema = z.object({
    currentPassword: z.string(),
    newPassword: z
        .string()
        .min(12, 'Password must be at least 12 characters.')
        .regex(/[A-Z]/, 'Password must contain an uppercase letter.')
        .regex(/[a-z]/, 'Password must contain a lowercase letter.')
        .regex(/[0-9]/, 'Password must contain a digit.')
        .regex(/[^A-Za-z0-9]/, 'Password must contain a symbol.'),
});
//# sourceMappingURL=me.js.map